class Toaster {
  domRoot: HTMLElement;
  params: any;
  scrollPosition: number;
  
  constructor(domRoot: HTMLElement, params: any) {
    this.domRoot = domRoot;
    this.params = params;
    this.scrollPosition = 0;
    this.init();
  }

  init() {
    window.addEventListener("scroll", () => {
      this.domRoot.classList.toggle('pop-up', window.scrollY < this.scrollPosition);
      
      this.scrollPosition = window.scrollY;
    });
  }
}

export default Toaster;